import Card from 'react-bootstrap/Card';
import Icon, { type IconName } from './Icon';
import type { TreeStats } from '../types';

type StatCardProps = {
  icon: IconName;
  label: string;
  value: string | number;
};

function StatCard({ icon, label, value }: StatCardProps) {
  return (
    <Card className="h-100 mb-0">
      <Card.Body className="d-flex align-items-center gap-3 py-3 px-3">
        <div
          className="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 bg-200 dark__bg-1100"
          style={{
            width: '2.35rem',
            height: '2.35rem',
            color: 'var(--falcon-navbar-vertical-default-link-active-color)'
          }}
        >
          <Icon name={icon} />
        </div>
        <div className="min-w-0 text-start">
          <div className="fs--1 text-600 text-truncate">{label}</div>
          <div
            className="fs-2 fw-bold lh-1 mt-1 text-truncate"
            title={String(value)}
          >
            {value}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

type ClusterStatsProps = {
  stats: TreeStats | null | undefined;
  pinnedCount?: number;
};

export default function ClusterStats({
  stats,
  pinnedCount = 0
}: ClusterStatsProps) {
  if (!stats) return null;

  const items: StatCardProps[] = [
    { icon: 'key', label: 'کلمه', value: stats.keywords },
    { icon: 'folder2', label: 'خوشه', value: stats.clusters },
    { icon: 'bar-chart', label: 'میزان جستجو', value: stats.totalVolumeLabel },
    {
      icon: 'speedometer2',
      label: 'میانگین سختی',
      value: stats.avgDifficulty ?? '—'
    },
    { icon: 'layers', label: 'عمق', value: stats.maxDepth },
    { icon: 'pin-angle', label: 'پین', value: pinnedCount }
  ];

  return (
    <div className="row g-3" dir="rtl" aria-label="آمار سئو درخت">
      {items.map(item => (
        <div key={item.label} className="col-6 col-md-4 col-xl-2">
          <StatCard icon={item.icon} label={item.label} value={item.value} />
        </div>
      ))}
    </div>
  );
}
